import { memo } from "react";
import { SpendCategoryInput } from "@/components/filters/SpendCategory/SpendCategoryInput";

const MemoizedSpendCategoryInput = memo(SpendCategoryInput);
MemoizedSpendCategoryInput.displayName = "MemoizedSpendCategoryInput";

export const renderSpendCategoryFieldSelector = (
  selectedItems: string[],
  onSelectItems: (ids: string[]) => void
) => (
  <MemoizedSpendCategoryInput
    selectedItems={selectedItems}
    onSpendCategorySelect={onSelectItems}
  />
);
